/**
 * Convivium - conferma della maggiore eta' per gli alcolici.
 *
 * La vendita di alcolici ai minori di 18 anni e' vietata, anche a distanza.
 * L'eta' non si puo' verificare: si chiede, e la risposta si scrive
 * nell'attributo di carrello "eta_confermata", che la funzione di validazione
 * rilegge al check-out. Il blocco vero e' quella funzione: questa spunta e'
 * solo il posto dove il cliente risponde.
 *
 * Perche' e' un elemento personalizzato in un file a parte, e non uno script
 * dentro lo snippet del carrello. Horizon aggiorna il carrello con morphSection,
 * che rimescola il DOM della sezione: uno script inline finisce dentro quel
 * rimescolamento, e se il morph inciampa il carrello resta nello stato
 * "disabilitato" in cui era stato messo all'inizio dell'operazione. Il sintomo
 * e' il cestino che smette di rispondere. Successo il 23 agosto 2026.
 *
 * Gli elementi personalizzati invece il browser li riattiva da solo ogni volta
 * che rientrano in pagina, senza che nessuno rilanci niente. E' lo stesso modo
 * in cui Horizon salva la nota del carrello (assets/cart-note.js), che e' un
 * attributo di carrello esattamente come questo.
 */
class ConfermaEta extends HTMLElement {
  connectedCallback() {
    if (this.dataset.pronto) return;
    this.dataset.pronto = 'si';
    this.addEventListener('change', this.salva);
  }

  salva = async (evento) => {
    const spunta = evento.target;
    if (!(spunta instanceof HTMLInputElement) || spunta.type !== 'checkbox') return;

    const avviso = this.querySelector('[data-cv-eta-avviso]');
    if (avviso) avviso.hidden = true;

    try {
      // Theme e' dichiarato con 'const' in snippets/scripts.liquid, quindi e' una
      // variabile globale ma NON una proprieta' di window: window.Theme e'
      // undefined e leggerne .routes fa saltare tutto. Va nominato nudo.
      // L'indirizzo non si scrive a mano: con un negozio multilingua diventa
      // /it/cart/update e la chiamata cade nel vuoto.
      const rotta =
        typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_update_url
          ? Theme.routes.cart_update_url
          : '/cart/update.js';

      const risposta = await fetch(rotta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { eta_confermata: spunta.checked ? 'si' : '' } }),
      });
      if (!risposta.ok) throw new Error(risposta.status);
    } catch (errore) {
      // La spunta si lascia dov'e' l'ha messa il cliente e si dice che non e'
      // stata salvata. Rimetterla indietro da sola sembra un guasto, e chi la
      // vede tornare al suo posto non capisce di dover riprovare.
      console.error('Convivium: conferma eta non salvata', errore);
      if (avviso) avviso.hidden = false;
    }
  };
}

if (!customElements.get('cv-conferma-eta')) {
  customElements.define('cv-conferma-eta', ConfermaEta);
}
